import React from 'react';

const HeroImage = ({ ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='782.12808'
      height='524.32607'
      viewBox='0 0 782.12808 524.32607'
      {...props}
    >
      <path
        d='M574.476,434.80785H219.65211A10.72787,10.72787,0,0,1,208.936,424.09169V198.55312A10.72788,10.72788,0,0,1,219.65211,187.837H574.476a10.72789,10.72789,0,0,1,10.71616,10.71616V424.09169A10.72788,10.72788,0,0,1,574.476,434.80785ZM219.65211,190.21833a8.3449,8.3449,0,0,0-8.33478,8.33479V424.09169a8.34489,8.34489,0,0,0,8.33478,8.33479H574.476a8.3449,8.3449,0,0,0,8.33479-8.33479V198.55312a8.3449,8.3449,0,0,0-8.33479-8.33479Z'
        transform='translate(-208.93596 -187.83696)'
        fill='#3f3d56'
      />
      <circle cx='217.01248' cy='143.94491' r='65.99829' fill='#ccc' />
      <path
        d='M934.28574,710.72638a246.30184,246.30184,0,0,1,20.38471-77.73489q4.60067-10.27759,10.12749-20.10267c.94659-1.6853-1.64386-3.1994-2.59041-1.51415a249.70657,249.70657,0,0,0-27.786,76.65535q-2.08614,11.26863-3.13582,22.69636c-.17783,1.9216,2.8233,1.90948,3,0Z'
        transform='translate(-208.93596 -187.83696)'
        fill='#e6e6e6'
      />
      <circle cx='763.12808' cy='410.86319' r='19' fill='#e6e6e6' />
      <path
        d='M936.22931,711.231a159.7877,159.7877,0,0,1,13.22451-50.43025q2.98467-6.66754,6.57018-13.04153a.97385.97385,0,0,0-1.68052-.98231,161.99656,161.99656,0,0,0-18.02606,49.7299q-1.35338,7.31049-2.03435,14.72419c-.11536,1.24663,1.83161,1.23877,1.94624,0Z'
        transform='translate(-208.93596 -187.83696)'
        fill='#e6e6e6'
      />
      <circle cx='751.8019' cy='450.71741' r='12.32619' fill='#e6e6e6' />
      <path
        d='M933.77287,710.06744a159.78742,159.78742,0,0,1-20.59035-47.89713q-1.74757-7.093-2.84086-14.324a.97385.97385,0,0,0-1.92923.25909,161.99654,161.99654,0,0,0,16.37365,50.29816q3.42929,6.59658,7.45221,12.861c.67579,1.0539,2.2061-.14981,1.53458-1.19706Z'
        transform='translate(-208.93596 -187.83696)'
        fill='#e6e6e6'
      />
      <circle cx='699.46095' cy='449.85215' r='12.32619' fill='#e6e6e6' />
      <path
        d='M835.16442,532.32815a10.05577,10.05577,0,0,0-4.4176-14.773l2.59077-35.64081-16.20274,9.07222.02382,32.45424a10.11027,10.11027,0,0,0,18.00575,8.88732Z'
        transform='translate(-208.93596 -187.83696)'
        fill='#ffb8b8'
      />
      <path
        d='M831.13364,393.782l4.4304,113.41817-18-1-4-119,3.796-1.78636A9.66542,9.66542,0,0,1,831.13364,393.782Z'
        transform='translate(-208.93596 -187.83696)'
        fill='#6c63ff'
      />
      <polygon points='566.53 512.201 554.271 512.201 548.438 464.913 566.532 464.913 566.53 512.201' fill='#ffb8b8' />
      <path
        d='M545.51336,508.69763h23.64387a0,0,0,0,1,0,0V523.5845a0,0,0,0,1,0,0H530.6265a0,0,0,0,1,0,0v0A14.88686,14.88686,0,0,1,545.51336,508.69763Z'
        fill='#2f2e41'
      />
      <polygon points='668.533 497.55 657.408 502.7 632.247 462.239 648.668 454.637 668.533 497.55' fill='#ffb8b8' />
      <path
        d='M859.64742,688.509h23.64387a0,0,0,0,1,0,0v14.88687a0,0,0,0,1,0,0H844.76056a0,0,0,0,1,0,0v0A14.88686,14.88686,0,0,1,859.64742,688.509Z'
        transform='translate(-421.36521 239.53615) rotate(-24.84116)'
        fill='#2f2e41'
      />
      <path
        d='M746.35619,545.71107,759,690l17-2,12.564-131.79985L858,682l18-5s-57.936-173.29985-62.436-187.79985c-4.93306-15.89543-44-22-44-22l-1.5-1.5C751.27731,488.29768,744.55346,517.61854,746.35619,545.71107Z'
        transform='translate(-208.93596 -187.83696)'
        fill='#2f2e41'
      />
      <circle cx='604.77727' cy='160.49782' r='24.56103' fill='#ffb8b8' />
      <path
        d='M831,386l-18.936,98.70015S786.1241,479.52,776.88387,473.28023c-3.65967-2.48-6.98-5.04-9.77979-7.36035a121.27211,121.27211,0,0,1-9.04-8.21973s6.64014-32.60986,9.00977-41.33984c2.75215-10.11231,12.19339-21.891,19.54665-29.91755a21.74462,21.74462,0,0,1,21.474-6.35628Z'
        transform='translate(-208.93596 -187.83696)'
        fill='#6c63ff'
      />
      <path
        d='M776.88387,473.28023c-3.65967-2.48-6.98-5.04-9.77979-7.36035,1.00977-14.93994,23.02-46.21973,31.93994-46.21973C799.044,419.70015,801.15389,467.91011,776.88387,473.28023Z'
        transform='translate(-208.93596 -187.83696)'
        opacity='0.2'
      />
      <path
        d='M731.58,512.51739a10.05581,10.05581,0,0,0,5.277-14.48823l23.35886-27.04334-18.41435-2.3969-19.35886,26.04829A10.11027,10.11027,0,0,0,731.58,512.51739Z'
        transform='translate(-208.93596 -187.83696)'
        fill='#ffb8b8'
      />
      <path
        d='M796.886,381.22505a16.32166,16.32166,0,0,0-3.02616.34653,12.49536,12.49536,0,0,0-8.91792,7.79987L756.064,449.70015l-31,33,15.5,12.5,49-44,19.576-53.2815A12.75365,12.75365,0,0,0,796.886,381.22505Z'
        transform='translate(-208.93596 -187.83696)'
        fill='#6c63ff'
      />
      <path
        d='M815.167,372.66971c3.49562-5.2323,6.25434-12.48756,2.40565-17.4659-3.79908-4.91417-11.29215-4.19018-17.11054-6.36467-8.104-3.02866-12.80409-12.5493-11.33824-21.07564s8.31031-15.59442,16.46405-18.48644,17.34838-1.95148,25.33312,1.37887c9.82931,4.09969,18.26114,12.03027,21.79685,22.07625s1.6456,22.10808-5.68929,29.82962c-7.8638,8.27835-20.20556,10.48454-31.62276,10.35068'
        transform='translate(-208.93596 -187.83696)'
        fill='#2f2e41'
      />
      <path
        d='M853.73579,343.71c1.00063,5.591,7.13393,8.76649,12.77077,9.46443s11.46786-.197,16.9553,1.269c9.67415,2.58443,16.05479,11.88814,19.56678,21.26546s5.0695,19.49827,9.63253,28.41158,13.41057,16.77136,23.38922,15.93771a25.732,25.732,0,0,1-48.39436-1.5693c-3.66576-11.31688.54222-24.81289-5.86842-34.83353-3.54741-5.54505-9.673-8.80672-15.57943-11.71292s-12.10571-5.88926-16.0657-11.14761-4.75122-13.56286.12875-17.98074'
        transform='translate(-208.93596 -187.83696)'
        fill='#2f2e41'
      />
      <path
        d='M973.33913,711.94759h-320.294a1.19069,1.19069,0,1,1,0-2.38137h320.294a1.19069,1.19069,0,1,1,0,2.38137Z'
        transform='translate(-208.93596 -187.83696)'
        fill='#3f3d56'
      />
      <path
        d='M405.98926,410.98926a66.99829,66.99829,0,1,1,66.99853-66.99854A67.07432,67.07432,0,0,1,405.98926,410.98926Zm0-131.99658a64.99829,64.99829,0,1,0,64.99853,64.998A65.07191,65.07191,0,0,0,405.98926,278.99268Z'
        transform='translate(-208.93596 -187.83696)'
        fill='#3f3d56'
      />
      <polygon
        points='154.974 37.028 93.245 143.945 216.703 143.945 154.974 37.028 93.245 143.945 216.703 143.945 154.974 37.028'
        fill='#cc5de8'
      />
    </svg>
  );
};

export default HeroImage;
